"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConverterFromNextProperty = void 0;

var Shrinkable_1 = require("../arbitrary/definition/Shrinkable");

var identifier = '__ConverterFromNextProperty__';

function fromNextValueToShrinkableFor(property) {
  return function fromNextValueToShrinkable(v) {
    var shrinker = function shrinker() {
      return property.shrink(v).map(fromNextValueToShrinkable);
    };

    if (!v.hasToBeCloned) {
      return new Shrinkable_1.Shrinkable(v.value_, shrinker);
    }

    return new Shrinkable_1.Shrinkable(v.value_, shrinker, function () {
      return v.value;
    });
  };
}

var ConverterFromNextProperty = /*#__PURE__*/function () {
  function ConverterFromNextProperty(property) {
    _classCallCheck(this, ConverterFromNextProperty);

    this.property = property;
    this[_a] = true;
    this.toShrinkable = fromNextValueToShrinkableFor(property);
  }

  _createClass(ConverterFromNextProperty, [{
    key: "isAsync",
    value: function isAsync() {
      return this.property.isAsync();
    }
  }, {
    key: "generate",
    value: function generate(mrng, runId) {
      var value = this.property.generate(mrng, runId);
      return this.toShrinkable(value);
    }
  }, {
    key: "run",
    value: function run(v) {
      return this.property.run(v);
    }
  }], [{
    key: "isConverterFromNext",
    value: function isConverterFromNext(property) {
      return identifier in property;
    }
  }]);

  return ConverterFromNextProperty;
}();

exports.ConverterFromNextProperty = ConverterFromNextProperty;
_a = identifier;